export const clientTypeOptions = [
  {
    value: "real_state_director",
    label: "Director de Inmobiliaria",
  },
  {
    value: "real_state_advisor",
    label: "Asesor Inmobiliario",
  },
  {
    value: "independent",
    label: "Asesor independiente",
  },
  {
    value: "property_manager",
    label: "Administrador de inmuebles",
  },
  {
    value: "owner",
    label: "Propietario de Inmueble",
  },
  {
    value: "credit_grantor",
    label: "Otorgante de crédito",
  },
];
